import { useColorMode } from "@/ui/hooks";
import { Image as BaseImage, ImageProps } from "@/ui";

type Props = {
  name: string;
  options?: {
    path?: "images" | "icons" | "animations";
    hasDarkMode?: boolean;
    imgProps?: ImageProps;
    alt?: string;
  };
};

export default function AppImage({ name, options = {} }: Props) {
  const { colorMode } = useColorMode();
  const { path = "images", hasDarkMode = true, imgProps, alt = name } = options;

  const colorModePrefix = hasDarkMode ? (colorMode === "dark" ? "dark_" : "light_") : "";

  const src = new URL(`../../assets/${path}/${colorModePrefix}${name}`, import.meta.url).href;
  return <BaseImage src={src} alt={alt} {...imgProps} />;
}
